import sanitizeHtml from 'sanitize-html';

// Used to sanitize CMS/backend-sourced rich text before it's rendered via
// dangerouslySetInnerHTML - allows common formatting/link markup, strips
// scripts/event handlers/iframes/etc. Works in both SSR and the browser
// (sanitize-html has no DOM dependency, unlike dompurify).
export const sanitizeRichText = (html: string | null | undefined): string => {
  if (!html) return '';

  return sanitizeHtml(html, {
    allowedTags: [
      'p', 'br', 'b', 'strong', 'i', 'em', 'u', 's', 'strike',
      'ul', 'ol', 'li', 'a', 'span', 'div',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'blockquote', 'code', 'pre', 'hr', 'sub', 'sup'
    ],
    allowedAttributes: {
      a: ['href', 'target', 'rel'],
      span: ['style'],
      div: ['style'],
      '*': ['class']
    },
    allowedStyles: {
      '*': {
        color: [/^#[0-9a-fA-F]{3,6}$/, /^rgb\(/],
        'text-align': [/^left$|^right$|^center$/]
      }
    },
    allowedSchemes: ['http', 'https', 'mailto', 'tel'],
    transformTags: {
      a: sanitizeHtml.simpleTransform('a', { rel: 'noopener noreferrer' })
    }
  });
};
